import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { debounceTime } from "rxjs/operators";
import { fromEvent } from "rxjs";
import { FranchiseStatus } from "src/app/franchise-app-global";
import {
  CrTypeEnum,
  FranchiseTypeEnum,
  ReferenceTypeEnum,
} from "../../../models/crType-enum";
import {
  Franchises,
  FranchisesSearchModel,
} from "../../../models/franchise-admin-list";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
import { FranchisesAdminService } from "../../../services/franchises-admin.service";
import { BaseComponent } from "src/app/shared/base/base-component";

@Component({
  selector: "app-franchise-admin-tab",
  templateUrl: "./franchise-admin-tab.component.html",
  styleUrls: ["./franchise-admin-tab.component.scss"],
})
export class FranchiseAdminTabComponent extends BaseComponent implements OnInit {
  @ViewChild("inputRef", { static: true }) inputRef: ElementRef;
  @ViewChild("dropdown") dropdown: NgbDropdown;

  franchisesStatus = FranchiseStatus;
  filterInputFocus: boolean = false;
  searchText: string = "";
  public pageSize: number = 10;
  public franchiseSearchModel: FranchisesSearchModel = {
    pageSize: this.pageSize,
    pageNumber: 1,
  };
  isInternal: boolean = true;
  @Input() franchises: Franchises;
  @Input() showStatus: false;
  @Output() public reloadGrid: EventEmitter<FranchisesSearchModel> =
    new EventEmitter<FranchisesSearchModel>();
  constructor(
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private franchisesAdminService: FranchisesAdminService
  ) {
    super();
  }

  ngOnInit(): void {
    this.franchiseSearchModel.crType =
      this.route.snapshot.data["isInternal"] === true
        ? CrTypeEnum.Internal
        : CrTypeEnum.External;
    this.isInternal = this.route.snapshot.data["isInternal"];

    const input$ = fromEvent(this.inputRef.nativeElement, "input").pipe(
      debounceTime(1500)
    );
    input$.subscribe(() => {
      this.refreshFranchises(1);
    });
  }

  refreshFranchises(page: number) {
    this.franchiseSearchModel.pageNumber = page;
    this.franchiseSearchModel.KeyWord = this.searchText;
    this.reloadGrid.emit(this.franchiseSearchModel);
  }
  onFocus() {
    this.filterInputFocus = true;
    // console.log("onFocus", this.filterInputFocus);
    this.cd.detectChanges();
  }
  onBlur() {
    this.filterInputFocus = false;
    // console.log("onBlur", this.filterInputFocus);
    this.cd.detectChanges();
  }
  onPageSizechange() {
    this.franchiseSearchModel.pageNumber = 1;
    this.franchiseSearchModel.pageSize = this.pageSize;
    this.reloadGrid.emit(this.franchiseSearchModel);
  }
  filterData(event: any) {
    let crDonor = event.form.value.grantMechanism.crDonor;
    let trademarkDonor = event.form.value.grantMechanism.trademarkDonor;

    this.franchiseSearchModel.RefrenceType =
      (crDonor === false && trademarkDonor === false) ||
        (crDonor === true && trademarkDonor === true)
        ? undefined
        : crDonor === true
          ? ReferenceTypeEnum.CrName
          : ReferenceTypeEnum.Trademark;

    let mainCr = event.form.value.franchiseType.MainCr;
    let minorCr = event.form.value.franchiseType.MinorCr;

    this.franchiseSearchModel.FranchiseType =
      (mainCr === false && minorCr === false) ||
        (mainCr === true && minorCr === true)
        ? undefined
        : mainCr === true
          ? FranchiseTypeEnum.Main
          : FranchiseTypeEnum.Normal;
    this.franchiseSearchModel.startDate = event.startDate;
    this.franchiseSearchModel.endDate = event.endDate;

    this.franchiseSearchModel.regionList = event.form.value.franchisRegion;
    this.franchiseSearchModel.cityList = event.form.value.franchisCity;
    this.franchiseSearchModel.tradeMarkName = event.form.value.tradeMarkName;
    this.refreshFranchises(1);
    this.toggleDropdown();
  }
  toggleDropdown() {
    if (this.dropdown.isOpen()) {
      this.dropdown.close();
    } else {
      this.dropdown.open();
    }
  }
  printFranchiseCertificate(franchiseNo: string) {
    this.franchisesAdminService.PrintFranchiseCertificate(franchiseNo);
  }
}
